import React, { useState,useRef,useEffect } from 'react';
import { numberRegex } from '../helper/Regex';
import { useNavigate } from 'react-router-dom';
import { useMyContext } from '../../AppContext';
import { AccountConfirmLinkingHeader } from '../helper/HeaderMakerforSocket';
import { v4 as uuidv4 } from 'uuid';
import { AccountConfirmLkingApi } from '../Apiservices';
import { toast} from 'react-toastify';
import mixpanel from 'mixpanel-browser';
import OtpInput from "react-otp-input";
mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, { debug: true });

export default function Otp({HandleAccountLinking,Setshow}) {

   const {Storage,SetStorage}=useMyContext();
   const [OtpResponse,SetOtpResponse]=useState();

    const [time,settime]=useState(60);

    const outerDivRef = useRef(null);

  const handleClick = (event) => {
    if (event.target === outerDivRef.current) {
    //  Setshow(false);
    }
  };

  useEffect(() => {

    if(Storage.Socketconnnection==null)
   {

       localStorage.clear();
       window.open(process.env.REACT_APP_CLOSING_URL, "_self");

   }
   else{

    const outerDiv = outerDivRef.current;
    if (outerDiv) {
      outerDiv.addEventListener('click', handleClick);
    }
  
    return () => {
      if (outerDiv) {
        outerDiv.removeEventListener('click', handleClick);
      }
    };
  }
   
  }, []);

const [otp,setOtp]=useState('');
const navigate=useNavigate();

useEffect(() => {
    const myInterval= setInterval(handletime, 1000);
     return ()=> {
         clearInterval(myInterval);
       };
 }, [time]);

 useEffect(() => {
  mixpanel.track("Viewed_BS_Bank_OTP", {
    Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
    user_type:localStorage.getItem('user_type')
  });
 
}, []);
 
 const [focusFirstInput, setFocusedInput] = useState(0); 

 useEffect(() => {
setFocusedInput(1);
 }, [])
    const handletime=()=>{
        if(time>0)
        {
        settime(time-1);
        }
    }
    const handlesubmit=(e)=>{
      mixpanel.track("Interacted_BS_Bank_OTP", {
        "Clicked on": "Confirm",
        Platform: window.innerWidth > 991 ? "web" : localStorage.getItem('platform')?localStorage.getItem('platform'):'M-site',
        user_type:localStorage.getItem('user_type')
      });
        e.preventDefault();
        // const otp=one+two+three+four+five+six;
  

    // api call for verify otp

    const Socketconnnection=Storage.Socketconnnection;
    if(!Socketconnnection)
    {
      setTimeout(()=>{

        localStorage.clear();
        window.open(process.env.REACT_APP_CLOSING_URL, "_self");

      },1000)
    }
    else{
    AccountConfirmLinkingHeader.sid=Storage?.sessionid;
 
    const message={
     header:AccountConfirmLinkingHeader,
     payload:{
         ver: "1.1.2",
         timestamp: new Date().toISOString(),
         txnid: uuidv4(),
         AccountsLinkingRefNumber:Storage?.AccountLinkingReferNumber,
         token:otp
     }
    };
 
    Socketconnnection.onclose=()=>{
     toast.error("Session Closed");
     localStorage.removeItem('insession');
     setTimeout(()=>{
           
           localStorage.clear();
           window.open(process.env.REACT_APP_CLOSING_URL, "_self");
     },1000)
    }
 
    Socketconnnection.send(JSON.stringify(message));
 
 
 Socketconnnection.onmessage = (event) => {
   const receivedMessage = JSON.parse(event.data);
 SetOtpResponse(receivedMessage);
 if(receivedMessage?.payload?.status=='FAILURE')
 {           
   setOtp('');
   toast.error("Invalid OTP,New OTP Sent",{
    position: toast.POSITION.TOP_CENTER,
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
   
  });

  settime(60); HandleAccountLinking()
 }else{
 HandleSubmitAccountConfirmLinking(receivedMessage);
 }   
   };
  }

    }
  const HandleSubmitAccountConfirmLinking=(receivedMessage)=>{
    const data={userId:Storage.userid,data:receivedMessage}
    // console.log(data)
AccountConfirmLkingApi(data).then((response)=>{
if(response?.status==200)
{
 
  navigate('/confirmconsent');
}
}).catch((error)=>{
  if(error?.response?.status==401)
  {
  toast.error("Your session is expired. Please try again");

  setTimeout(()=>{
    localStorage.clear();
           window.open(process.env.REACT_APP_CLOSING_URL, "_self");

  },1000)
}else{
  Storage.internalservererror=true;
  SetStorage(Storage);
  navigate('/finalresult');
}
})

  }



 
  return (
    <div className='otpcontainer' ref={outerDivRef}>
    <div className='otp'>
<div className='inp'>
<h1>Enter OTP</h1>
<p><span>{Storage?.selectedbank?.fip_name} </span>has sent OTP for verification</p>

<OtpInput
                containerStyle="otp-input"
                numInputs={6}
                value={otp}
                inputType='number'
                onChange={(value) => {
                    setOtp(value);
                }}
                renderInput={(props,index) => <input inputMode='nummeric' {...props} className={otp && otp[index] ? 'active' : ''}
                autoFocus={(index === 0)}
                />}
              />
<div className='resend'>
<p><span className='didnotreceive'>Didn’t receive OTP?</span><br/>
{time>0?<span className='receive'>Re-send in 00:{time}s</span>:<span className='receive2' onClick={(e)=>{e.preventDefault(); settime(60); HandleAccountLinking()}}>Re-send</span>}</p>
<button disabled={otp.length!=6} onClick={handlesubmit}> Confirm</button>
</div>


</div>
    </div>
    </div>
  )
}
